import React, { useState, useEffect } from "react";
// import "./Prizes.css";
import "./Howtoplay.css";

import prizesImage from "../../assets/Prizes.png";
import Navbar from "../../components/Navbar/Navbar";
import Form from "../../components/Form/Form";
import three from "../../assets/three.png";
import one from "../../assets/one.png";
import two from "../../assets/two.png";
import four from "../../assets/four.png";
import prizes_spinner from "../../assets/prizes_spinner.png";
import { Redirect, useHistory } from "react-router-dom";

function GetWindowDimensions() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return width;
}



const Howtoplay = () => {
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const slideImages = [one, two, three, four];
  const [currentImg, setCurrentImg] = useState(one);

  const onClick = (e) =>{
      setCurrentImg(
        slideImages[Math.floor(Math.random() * slideImages.length)]
      );
  } 

  const checkNext = () => {
    const labels = document.querySelectorAll("#slider label");
    const nextIndex =
      selectedIndex === labels.length - 1 ? 0 : selectedIndex + 1;
    setSelectedIndex(nextIndex);
  };

  const check = (index) => setSelectedIndex(index);
  const width = GetWindowDimensions();
  if (localStorage.getItem('authed')=='authenticated') {
    return <Redirect to="/play" />;
  }
  return (
    <div className="container">
      <Navbar />
      {width >= 1223 ? (
         <div className="row">
         <div className="col-sm-12 col-md-4 order-1 order-sm-2 ">
           <h6 className="text-white mt-5">
         <h2 className="header-text pt-5"> HOW TO PLAY</h2>
         {/* <h2 className="header-text">AMAZING PRIZES</h2> */}
         <br></br>
             {/* Enter your number below and spin the wheel to be our next lucky
             winner */}
           </h6>
           {/* <Form /> */}
           <div>

           </div>
         </div>
 
         <div className="order-sm-12 col-md-8">
           <div class="containers mt-5 pt-5">
             <div class="spinner"><img src={prizes_spinner}></img></div>
             {/* <button onClick={checkNext}>{"<"}</button> */}
             <div class="slider-content text-center">
               <div class="item">
                 <div class="data-image">
                     
                     </div>
                 <h2 className="bordered-number">1</h2>
                 <h6 className="h5-bold">Enter your phone number</h6>
                 <p>Inorder to qualify,enter your<br /> phone number and mobile network</p>
               </div>
               <div class="item">
                 <div class="data-image">
                   <h2 className="bordered-number">2</h2>
                 </div>
                 <h6 className="h5-bold">Enter OTP Code</h6>
 
                 
                 <p>An OTP code is sent to your <br /> Mobile number</p>
               </div>
               <div class="item">
                 <div class="data-image">
                   <h2 className="bordered-number">3</h2>
 
                 </div>
                 <h6 className="h5-bold">Spin the Wheel</h6>
                 <p>Each Spin Cost N30,The more you <br /> spin,The more your chance of winning</p>
               </div>
               <div class="item">
                 <div class="data-image">
                   <h2 className="bordered-number">4</h2>
                 </div>
                 <h6 className="h5-bold">Winner</h6>
                 <p>Win Amazing prizes. Data,<br />  Generator and Cash Prizes.</p>
               </div>
             </div>
             {/* <button onClick={checkNext}>{">"}</button> */}
           </div>
         </div>
       </div>
      ) :  <div className="row">
      <div className="col-md-6 offset-md-3">
        <div className="text-center ">
          <div class="spinner pt-5">
            <img style={{maxHeight: "200px",
                    minHeight: "150px",   maxWidth: "200px",minWidth: "150px"}} src={prizes_spinner}></img>
          </div>
          <div class="item">
            <div class="slider-content">
              <img
                className="second mb-2 pb-2 "
                src={currentImg}
                alt="Logo"
                onClick={onClick}
                style={{maxHeight: "600px",
                    minHeight: "400px",   maxWidth: "600px",minWidth: "400px"}}
              />
            </div>
          </div>
        </div>

        <div className="container">
          <h2 className="header-text-mobile text-center">
            {" "}
            SPIN TO WIN AMAZING PRIZES
          </h2>
          {/* <h2 className="header-text">AMAZING PRIZES</h2> */}
          <br></br>
        </div>
        <h6 className="text-white mt-5">
          Enter your number below and spin the wheel to be our next lucky
          winner
        </h6>
        <Form />
      </div>
    </div>}
    </div>
  );
};

export default Howtoplay;
